import React from "react";
import { Stack, Typography, Box } from "@mui/material";
import formBackgroundImage from "url:src/assets/images/top/form-background.jpg";
import { SimpleForm } from "./SimpleForm";

type Props = {
  cities: string[];
  ctaClassName?: string;
};

export default function SimpleFormSection({ cities, ctaClassName }: Props) {
  return (
    <Box
      sx={{
        backgroundImage: `url(${formBackgroundImage})`,
        backgroundSize: "cover",
        overflow: "hidden",
        position: "relative",
        width: "100%",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "primary.dark",
          opacity: 0.86,
        }}
      />
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          padding: "60px 20px",
          color: "white",
        }}
      >
        <Stack spacing={3}>
          <Stack alignItems="center" spacing={1}>
            <Typography variant="h6" fontWeight="bold" color="white" textAlign="center">
              無料売却AI査定
            </Typography>
            <Typography color="white" lineHeight={1.5} letterSpacing={0}>
              「売却するかは未定...」といった方も大歓迎！ <br />
              最短60秒で、今の不動産価格を
              <br />
              AIが自動でチェック。 <br />
              まずは気軽に価格を見てみませんか？
            </Typography>
          </Stack>

          <SimpleForm cities={cities} ctaClassName={ctaClassName}/>
        </Stack>
      </Box>
    </Box>
  );
}
